import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import ProtectedRoute from './routes/ProtectedRoute';
import AdminRoute from './routes/AdminRoute';
import HomePage from './pages/HomePage';
import Who from './pages/Who';
import Dev from './pages/Dev';
import Careers from './pages/Careers';
import Parts from './pages/Parts';
import ActiveOffers from './pages/ActiveOffers';
import RequestQuote from './pages/RequestQuote';
import BuildPrice from './pages/BuildPrice';
import SignUp from './pages/SignUp';
import VerifyEmail from './pages/VerifyEmail';
import ResetPassword from './pages/ResetPassword';
import NotAuthorizedPage from './pages/NotAuthorizedPage';
import Profile from './pages/Profile';
import Vehicles from './pages/Vehicles';
import ContactUs from './pages/ContactUs';
import EditWebsite from './pages/admin/EditWebsite';
import SetVehicle from './pages/admin/SetVehicle';
import EditClass from './pages/admin/EditClass';
import EditModel from './pages/admin/EditModel';
import EditTrim from './pages/admin/EditTrim';
import EditAccessory from './pages/admin/EditAccessory';
import EditPackage from './pages/admin/EditPackage';
import SetOffer from './pages/admin/SetOffer';
import SetSlider from './pages/admin/SetSlider';
import SetDev from './pages/admin/SetDev';
import SetPart from './pages/admin/SetPart';
import Sidebar from './components/Sidebar';
import Header from './components/Header';
import Footer from './components/Footer';
import { UserProvider } from './context/UserContext';
import './App.css';

function App() {
  return (
    <UserProvider>
      <Router>
        <div className="app-container">
          <Sidebar />
          <div className="main-content">
            <Header />
            <Routes>
                <Route path="/" element={<HomePage />} />
                <Route path="/who" element={<Who />} />
                <Route path="/dev" element={<Dev />} />
                <Route path="/careers" element={<Careers />} />
                <Route path="/parts" element={<Parts />} />
                <Route path="/offers" element={<ActiveOffers />} />
                <Route path="/quote" element={<RequestQuote />} />
                <Route path="/buildnprice" element={<BuildPrice />} />
                <Route path="/signup" element={<SignUp />} />
                <Route path="/verify-email" element={<VerifyEmail />} />
                <Route path="/reset-password" element={<ResetPassword />} />
                <Route path="/not-authorized" element={<NotAuthorizedPage />} />
                <Route path="/profile" element={<ProtectedRoute><Profile /></ProtectedRoute>} />
                <Route path="/vehicles/:id" element={<Vehicles />} />
                <Route path="/contact-us" element={<ContactUs />} />

                <Route path="/edit-website" element={<AdminRoute><EditWebsite /></AdminRoute>} />
                <Route path="/set-vehicle" element={<AdminRoute><SetVehicle /></AdminRoute>} />
                <Route path="/edit-class/:id" element={<AdminRoute><EditClass /></AdminRoute>} />
                <Route path="/edit-model/:id" element={<AdminRoute><EditModel /></AdminRoute>} />
                <Route path="/edit-trim/:id" element={<AdminRoute><EditTrim /></AdminRoute>} />
                <Route path="/edit-accessory/:id" element={<AdminRoute><EditAccessory /></AdminRoute>} />
                <Route path="/edit-package/:id" element={<AdminRoute><EditPackage /></AdminRoute>} />
                <Route path="/set-offer" element={<AdminRoute><SetOffer /></AdminRoute>} />
                <Route path="/set-slider" element={<AdminRoute><SetSlider /></AdminRoute>} />
                <Route path="/set-dev" element={<AdminRoute><SetDev /></AdminRoute>} />
                <Route path="/set-part" element={<AdminRoute><SetPart /></AdminRoute>} />
            </Routes>
          </div>
        </div>
        <Footer />
      </Router>
    </UserProvider>
);
}

export default App;